//  Name: profile
import { mapGetters, mapMutations } from 'vuex'
import Eventbus from '@/helpers/event-bus'
import Datepicker from 'vuejs-datepicker'
import '@/components/select-country'
import '@/components/input-phone'
import '@/components/editable-name'
import '@/components/upload-image'

export default {
  data () {
    return {
      temp: null,
      stats: {
        courses: null,
        years: null
      }
    }
  },
  watch: {
    'temp': function (val) {
      let date = new Date(val.birthdate)
      if (isNaN(date)) {
        date = new Date()
      }
      this.temp.birthdate = date
    }
  },
  computed: mapGetters({
    user: 'user'
  }),
  methods: {
    ...mapMutations([
      'UPDATE_AVATAR'
    ]),
    saveData () {
      var vm = this
      var chunk = Object.assign({}, vm.temp)

      chunk.birthdate = vm.temp.birthdate.getTime()

      Eventbus.$emit('waitMessage')
      vm.$http.post(
        'users/edit/',
        chunk
      ).then(function (response) {
        const data = response.body
        vm.$store.dispatch('update', chunk)
        Eventbus.$emit('successMessage', data.message)
      }, function (error){
        Eventbus.$emit('errorMessage', 'Problemas de comunicación con el servidor')
        console.log(error)
      })
    },
    avatarChanged (url) {
      this.UPDATE_AVATAR(url)
      Eventbus.$emit('successMessage', 'Imagen de perfil actualizada con éxito')
    },
    avatarError (error) {
      Eventbus.$emit('errorMessage', error)
    }
  },
  mounted () {
    var vm = this
    vm.$set(vm, 'temp', Object.assign({}, vm.user))
    Eventbus.$emit('waitMessage')
    vm.$http.get('users/meta/' + vm.user.id + '/')
    .then(function (response) {
      Eventbus.$emit('dismissMessage')
      vm.$set(vm, 'stats', response.body.stats)
    }, function (error) {
      Eventbus.$emit('errorMessage', 'Problemas de comunicación con el servidor')
      console.log(error)
    })

  },
  components: {
    Datepicker
  }
}



// WEBPACK FOOTER //
// ./src/pages/profile/script.js